import { motion } from 'framer-motion';
import { Card } from '../../../design-system/components';

interface StepCardProps {
  step: number;
  icon: string;
  title: string;
  description: string;
  index: number;
}

/** One How It Works step: the emoji in a peach disc, "Step N", the title and a line. */
export default function StepCard({ step, icon, title, description, index }: StepCardProps) {
  return (
    <motion.div
      className="ee-landing-cell"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.12 }}
    >
      <Card padding="lg" className="ee-landing-tile--center">
        <div className="ee-landing-tile__emoji">{icon}</div>
        <div className="ee-landing-step__label">Step {step}</div>
        <h3 className="ee-landing-tile__title">{title}</h3>
        <p className="ee-landing-tile__text">{description}</p>
      </Card>
    </motion.div>
  );
}
